import ApiPlan from 'types/api/Plan';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import Element from 'types/redux/Element';
import ListCollection from 'types/redux/ListCollection';

import Plan from 'models/Plan';

import { withVariables } from 'utils/string';
import { request } from 'services/Api';

import { ELEMENT_MARKUP } from '../consts/api';

export interface ListParams extends ListParamsDefault {
}

export interface ListResponse {
    [ApiResources.Plans]: ListCollection<Plan>;
}

export const list = async (params: ListParams): Promise<ListResponse> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicPlans, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource: ListCollection<ApiPlan> = data && data[ApiResources.Plans];

    if (!data || !resource) {
        return null;
    }

    return {
        [ApiResources.Plans]: {
            ...resource,
            elements: resource.elements.map(element => new Plan(element)),
        },
    };
};

export interface SingleParams {
    id: string;
}

export const single = async (params: SingleParams): Promise<Element<Plan>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicPlan, params),
        params,
    });

    const data = response?.payload?.data;
    const resource: ApiPlan = data && data[ApiResources.Plan];

    if (!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...ELEMENT_MARKUP,
        isLoaded: true,
        data: new Plan(resource),
    };
};
